module.exports = __webpack_public_path__ + "static/andrea-williams.35b020d5.webp";